import React, { useState } from 'react';
import Popup from 'antd-mobile/es/components/popup';
import SearchBar from 'antd-mobile/es/components/search-bar';
import CheckList from 'antd-mobile/es/components/check-list';
import Input from 'antd-mobile/es/components/input';
import DotLoading from 'antd-mobile/es/components/loading';
import Empty from 'antd-mobile/es/components/empty';

import styles from './companyPopup.module.scss';
import { useTranslation } from '../../LangContext';
import PopupTitle from '../PopupTitle';
import { useOptions } from '../../hooks/useOptions';

interface Props {
  value?: string;
  onChange?(val: string): void;
  ItemConfig: {
    queryFunc: any;
    placeholder: string;
    title: string;
    fetchingTips: string;
    notFoundContent: string;
  };
}

export const ItemPopup = (props: Props) => {
  const [visible, setVisible] = useState(false);
  const { value, onChange, ItemConfig } = props;
  const { queryFunc, placeholder, title, fetchingTips, notFoundContent } = ItemConfig;
  const { options, onSearch, fetching } = useOptions({ ...queryFunc });
  const { t } = useTranslation();
  const itemPlaceholder = t(placeholder);
  const itemTitle = t(title);
  const itemFetchingTips = t(fetchingTips);
  const itemNotFoundContent = t(notFoundContent);

  const onSelectItem = (val: Array<string>) => {
    onChange?.(val[0] || '');
    setVisible(false);
  };

  const renderList = () => {
    if (options.length > 0) {
      return (
        <CheckList onChange={onSelectItem}>
          {options.map((item, index) => {
            return (
              <CheckList.Item value={item.value} key={index}>
                {item.label}
              </CheckList.Item>
            );
          })}
        </CheckList>
      );
    }
    return (
      <Empty
        style={{ padding: '64px 0' }}
        imageStyle={{ width: 128 }}
        description={<div style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: itemNotFoundContent }} />}
      />
    );
  };
  return (
    <>
      <div onClick={() => setVisible(true)}>
        <Input placeholder={itemPlaceholder} value={value} readOnly />
      </div>
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        forceRender
        destroyOnClose
        closeOnMaskClick
        style={{ '--z-index': '100001' }}
        bodyStyle={{ height: 'calc(100% - 8.75rem)', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}
      >
        <PopupTitle onClose={() => setVisible(false)} title={itemTitle} />
        <div className={styles.container}>
          <div className={styles.searchBarContainer}>
            <div className={styles.searchBarLeft}>
              <SearchBar placeholder={itemPlaceholder} onChange={onSearch} />
            </div>
          </div>
          <div className={styles.options}>
            {fetching ? (
              <div className="flex justify-center align-middle">
                <DotLoading color="default" />
                <span> {itemFetchingTips}</span>
              </div>
            ) : (
              renderList()
            )}
          </div>
        </div>
      </Popup>
    </>
  );
};
